import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DashboardApi } from '../api/dashboard-api';
import { DashboardPeakTimeReport, DashboardReportsCharts } from '../model';
import { AppConsumptionModel } from '../model/app-consumption.model';
import { Repository } from './repository';
import { filter, map } from 'rxjs/operators';
import { DashboardContactUsMessagesFilters, PeakReportViewType, TotalChartsMap } from 'src/app/shared/common';
import { CurrentCallsChart } from '../model/current-calls-chart-model';
import { DashboardBalanceReport } from '../model/dashboard-balance-report';
import {
  ContactUsMessageSendReplyForm,
  DashboardBalanceReportForm,
  DashboardPeakTimeReportForm,
  DataWithPagination,
} from '../../interface';
import { ContactUsMessages } from '../model/contact-us-messages-model';
import { ContactUsMessageDetails } from '../model/contact-us-message-details-model';
import { DashboardChartsType } from '../../common';
import { subtractDays } from 'src/app/shared/helper';
import { DateFilterWithPagination } from 'src/app/shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class DashboardRepository extends Repository {
  constructor(private dashboardApi: DashboardApi) {
    super();
  }

  getDashboardReportsCharts(): Observable<DashboardReportsCharts> {
    return this.dashboardApi.getReportsCharts();
  }

  getAppConsumption(): Observable<AppConsumptionModel> {
    return this.dashboardApi.getAppConsumption();
  }

  /* getMaleTeachersReport() {
    return this.dashboardApi.getReportsCharts(DashboardChartsType.TeachersMale).pipe(
      map((res) => {
        return [res.countOfActiveMaleTeachers, res.countOfBlockedMaleTeachers];
      })
    );
  } */

  /* getFemaleTeachersReport() {
    return this.dashboardApi.getReportsCharts(DashboardChartsType.TeachersFemale).pipe(
      map((res) => {
        return [res.countOfActiveFemaleTeachers, res.countOfBlockedFemaleTeachers];
      })
    );
  } */

  /* getMaleStudentsReport() {
    return this.dashboardApi.getReportsCharts(DashboardChartsType.StudentsMale).pipe(
      map((res) => {
        return [res.countOfActiveMaleStudents, res.countOfBlockedMaleStudents];
      })
    );
  } */

  /* getFemaleStudentsReport() {
    return this.dashboardApi.getReportsCharts(DashboardChartsType.StudentsFemale).pipe(
      map((res) => {
        return [res.countOfActiveFemaleStudents, res.countOfBlockedFemaleStudents];
      })
    );
  } */

  getActiveTeachersReport(dateRange?: DateFilterWithPagination): Observable<DashboardReportsCharts> {
    return this.dashboardApi.getReportsCharts({ userType: 'User_T', ...dateRange }).pipe(
      map((res) => {
        const filteredObject = Object.fromEntries(
          Object.entries(res).filter(([key, value]) => value !== null && value !== undefined)
        );
        return filteredObject as DashboardReportsCharts;
      })
    );
  }

  getActiveStudentsReport(dateRange?: DateFilterWithPagination): Observable<DashboardReportsCharts> {
    return this.dashboardApi.getReportsCharts({ userType: 'User_S', ...dateRange }).pipe(
      map((res) => {
        const filteredObject = Object.fromEntries(
          Object.entries(res).filter(([key, value]) => value !== null && value !== undefined)
        );
        return filteredObject as DashboardReportsCharts;
      })
    );
  }

  getMinutesReport() {
    return this.dashboardApi.getReportsCharts({ type: DashboardChartsType.ConsumedMinutes }).pipe(
      map((res) => {
        const years = new Set(res.minutesReport.map((item) => item.year));
        const yearsMap: TotalChartsMap = new Map();
        years.forEach((year) => {
          let total: number[] = [];
          let totalRetrieved: number[] = [];
          res.minutesReport.forEach((item) => {
            if (item.year == year) {
              total.push(item.totalCount);
              totalRetrieved.push(item.totalRetrieved);
            }
          });
          yearsMap.set(year.toString(), { total: total, retrieved: totalRetrieved });
        });
        return yearsMap;
      })
    );
  }

  // current calls charts
  getCountOfCurrentCallsReport(category?: string, dateRange?: DateFilterWithPagination): Observable<CurrentCallsChart> {
    return this.dashboardApi.getCountOfCurrentCallsReport(category, dateRange);
  }

  getBalanceReport(balanceForm: DashboardBalanceReportForm): Observable<DashboardBalanceReport> {
    balanceForm.toDate = balanceForm.toDate ? new Date(balanceForm.toDate.setHours(23, 59, 59)) : null;
    return this.dashboardApi.getBalanceReport(balanceForm);
  }

  getPeakTimeReport(peakForm: DashboardPeakTimeReportForm): Observable<DashboardPeakTimeReport> {
    const form: DashboardPeakTimeReportForm = {
      filterType: peakForm.viewType,
      fromDate:
        peakForm.date?.start && peakForm.viewType !== PeakReportViewType.HOUR
          ? new Date(peakForm.date?.start)
          : peakForm.date?.start && peakForm.viewType == PeakReportViewType.HOUR
          ? subtractDays(1, new Date(peakForm.date?.start))
          : null,
      toDate: peakForm.date?.end ? new Date(peakForm.date?.end) : null,
      gender: peakForm.gender,
    };
    return this.dashboardApi.getPeakTimeReport(form);
  }

  getContactUsMessages(
    filters: DashboardContactUsMessagesFilters
  ): Observable<DataWithPagination<ContactUsMessages[]>> {
    return this.dashboardApi.getContactUsMessages(filters);
  }

  getContactUsMessageDetails(messageId: string): Observable<ContactUsMessageDetails[]> {
    return this.dashboardApi.getContactUsMessageDetails(messageId);
  }

  contactUsMessageReply(formReply: ContactUsMessageSendReplyForm): Observable<string> {
    return this.dashboardApi.contactUsMessageReply(formReply);
  }
}
